import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageModule } from '../image/image.module';
import { ImageWithLabelComponent } from './image-with-label.component';

@NgModule({
  declarations: [ImageWithLabelComponent],
  imports: [CommonModule, ImageModule],
  exports: [ImageWithLabelComponent]
})
export class ImageWithLabelModule {}
